import React from 'react'

import { useBanner } from '@providers/BannerProvider'

const Banner: React.FC = () => {
  const { banner } = useBanner()

  if (!banner) return null
  return (
    <div className="justify-center flex py-4 border-2 border-orange">
      <span>{banner.message}</span>
      {banner.action && (
        <button className="ml-1 underline-link" onClick={banner.action.action}>
          {banner.action.label}
        </button>
      )}
    </div>
  )
}

export default Banner
